// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__1CiJB","link":"About_link__pEK67","headshot":"About_headshot__3hQPZ"};